import { render, staticRenderFns } from "./ExtensionField.vue?vue&type=template&id=20cb0a50&"
import script from "./ExtensionField.vue?vue&type=script&lang=js&"
export * from "./ExtensionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports